/** Evită import circular main ↔ auth-ui: implementarea vine din main.ts după definirea showSection. */

let _showSectionImpl: (secId: string) => void = () => {};

export function registerShowSection(fn: (secId: string) => void): void {
    _showSectionImpl = fn;
}

export function navigateToSectionId(secId: string): void {
    _showSectionImpl(secId);
}
